import { LegalPage } from "@/components/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage eyebrow="Legal" title="Privacy Policy" updated="Effective 1 June 2026" testid="privacy-page">
      <p>KRV Prime ("we", "us", "our"), an independent financial-market education and information platform, respects your privacy. This policy explains what we collect, why, and your choices.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Account details</strong> you provide — name, email, mobile number and user category when you register or log in.</li>
        <li><strong>Communications</strong> — messages, enquiries, newsletter sign-ups and testimonials you submit.</li>
        <li><strong>Usage data</strong> — pages viewed and interactions, collected to improve the platform.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To create and secure your account and provide access to courses, tools and research.</li>
        <li>To send verification emails, service notifications and (with consent) educational newsletters.</li>
        <li>To respond to your enquiries and improve our content and services.</li>
      </ul>

      <h2>3. Sharing</h2>
      <p>We do not sell your personal data. We share it only with trusted service providers that help us operate (e.g. email delivery, SMS/OTP, hosting), and where required by law.</p>

      <h2>4. Cookies</h2>
      <p>We use essential cookies and local storage to keep you signed in and remember preferences. You can clear these via your browser settings.</p>

      <h2>5. Data Security &amp; Retention</h2>
      <p>We apply reasonable technical and organisational measures to protect your data and retain it only as long as needed for the purposes above or as required by law.</p>

      <h2>6. Your Rights</h2>
      <p>You may request access to, correction of, or deletion of your personal data, and may unsubscribe from newsletters at any time. Contact us at contact@krvprime.com.</p>

      <h2>7. Account &amp; Data Deletion</h2>
      <p>You can request permanent deletion of your KRV Prime account and all associated data at any time.</p>
      <p><strong>How to request deletion:</strong></p>
      <ul>
        <li><strong>In the app:</strong> go to Profile → tap "Delete Account" and confirm. Your account and data are removed immediately.</li>
        <li><strong>On the web:</strong> visit <a href="https://krvprime.com/account-deletion" style={{ color: "#0A192F", textDecoration: "underline", wordBreak: "break-all" }}>https://krvprime.com/account-deletion</a> and submit your registered email or mobile number.</li>
        <li><strong>By email:</strong> write to contact@krvprime.com from your registered email with the subject "Delete my account".</li>
      </ul>
      <p><strong>What gets deleted:</strong> Your profile, name, email address, mobile number, profile photo, saved addresses, bookmarks and learning activity are permanently deleted. This action cannot be undone.</p>
      <p><strong>Processing time:</strong> Requests are processed within 7 days. Data required for legal, tax or fraud-prevention purposes (if any) may be retained only as long as legally required, after which it is deleted.</p>

      <h2>8. Children</h2>
      <p>The platform is intended for users aged 18 and above. We do not knowingly collect data from children.</p>

      <h2>9. Changes</h2>
      <p>We may update this policy from time to time. Material changes will be reflected on this page with a revised effective date.</p>

      <h2>10. Contact</h2>
      <p>Questions? Email <strong>contact@krvprime.com</strong>.</p>
    </LegalPage>
  );
}
